<template>
    <div>
        <h1 class="text-center">{{$t('message.login')}}</h1>
        <vue-form-generator class="auth-form" :schema="schema" :model="model" :options="formOptions" @validated="onValidated">
        </vue-form-generator>
        <div class="mx-auto mt-4 max-w-md text-center">
            <strong class="text-success">{{$t('message.first_time')}}</strong>
            <router-link to="/signup" class="ml-1 text-link hover:underline">{{$t('message.signup_link')}}</router-link>
            <br>
            <router-link to="/reset-password" class="text-link hover:underline">{{$t('message.forgot_password')}}?</router-link>
        </div>
    </div>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import storage, {AUTH_REQUEST} from '../_store'
    import mixins from '../modules/mixins'

    export default {
        name: 'Login',
        mixins: [mixins],
        data () {
            return {
                validForm: false,
                model: {
                    name: this.$route.query.email || '',
                    password: '',
                    showPassword: false,
                    remember: true
                },
                schema: {
                    fields: [{
                        type: 'input',
                        inputType: 'email',
                        label: this.$t('message.email'),
                        i18n: {
                            label: 'message.email'
                        },
                        inputName: 'email',
                        model: 'name',
                        required: true,
                        validator: VueFormGenerator.validators.email
                    }, {
                        type: 'input',
                        inputType: 'password',
                        label: this.$t('message.password'),
                        i18n: {
                            label: 'message.password'
                        },
                        inputName: 'password',
                        model: 'password',
                        required: true,
                        validator: VueFormGenerator.validators.string
                    }, {
                        type: 'checkbox',
                        label: this.$t('message.show_password'),
                        i18n: {
                            label: 'message.show_password'
                        },
                        model: 'showPassword'
                    }, {
                        type: 'checkbox',
                        label: this.$t('message.remember'),
                        i18n: {
                            label: 'message.remember'
                        },
                        model: 'remember'
                    }, {
                        type: 'submit',
                        buttonText: this.$t('message.login'),
                        i18n: {
                            buttonText: 'message.login'
                        },
                        validateBeforeSubmit: true,
                        onSubmit: this.login
                    }]
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChange: true
                }
            }
        },
        methods: {
            onValidated (isValid) {
                this.validForm = isValid
            },
            login () {
                if (!this.validForm) {
                    return
                }
                this.model.name = this.model.name.trim()
                storage.dispatch(AUTH_REQUEST, {
                    name: this.model.name,
                    password: this.model.password,
                    remember: this.model.remember
                }).then((resp) => {
                    if (typeof resp.data.errors != 'undefined') {
                        for (let i of resp.data.errors) {
                            this.$b_notify({
                                type: i[1],
                                content: i[0]
                            })
                        }
                    }
                    this.$router.push('/')
                }).catch(err => {
                    this.$b_notify({
                        type: 'danger',
                        content: err.response.data.message || err.message
                    })
                })
            }
        },
        watch: {
            'model.showPassword' (visible) {
                this.schema.fields[1].inputType = visible ? 'text' : 'password'
            }
        }
    }
</script>

<style scoped>
    .auth-form {
        max-width: 500px;
        margin: 0 auto;
        padding: 20px;
        border: 1px solid #e4e4e4;
        box-shadow: rgba(0, 0, 0, 0.1) 0 3px 6px 0;
        border-radius: 4px;
    }
</style>
